package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.DiscordSimpleIcons: ImageVector
    get() {
        if (_discordSimpleIcons != null) {
            return _discordSimpleIcons!!
        }
        _discordSimpleIcons = Builder(name = "DiscordSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(20.32f, 4.37f)
                arcToRelative(19.79f, 19.79f, 0.0f, false, false, -4.89f, -1.52f)
                arcToRelative(0.07f, 0.07f, 0.0f, false, false, -0.08f, 0.04f)
                curveToRelative(-0.21f, 0.38f, -0.45f, 0.87f, -0.61f, 1.25f)
                curveToRelative(-1.85f, -0.28f, -3.68f, -0.28f, -5.49f, 0.0f)
                curveToRelative(-0.16f, -0.39f, -0.41f, -0.87f, -0.62f, -1.25f)
                arcToRelative(0.08f, 0.08f, 0.0f, false, false, -0.08f, -0.04f)
                arcToRelative(19.74f, 19.74f, 0.0f, false, false, -4.89f, 1.52f)
                arcToRelative(0.07f, 0.07f, 0.0f, false, false, -0.03f, 0.03f)
                curveTo(0.53f, 9.05f, -0.32f, 13.58f, 0.10f, 18.06f)
                arcToRelative(0.08f, 0.08f, 0.0f, false, false, 0.03f, 0.06f)
                curveToRelative(2.05f, 1.51f, 4.04f, 2.42f, 5.99f, 3.03f)
                arcToRelative(0.08f, 0.08f, 0.0f, false, false, 0.08f, -0.03f)
                curveToRelative(0.46f, -0.63f, 0.87f, -1.30f, 1.23f, -1.99f)
                arcToRelative(0.08f, 0.08f, 0.0f, false, false, -0.04f, -0.11f)
                curveToRelative(-0.65f, -0.25f, -1.27f, -0.55f, -1.87f, -0.89f)
                arcToRelative(0.08f, 0.08f, 0.0f, false, true, -0.01f, -0.13f)
                curveToRelative(0.13f, -0.09f, 0.25f, -0.19f, 0.37f, -0.29f)
                arcToRelative(0.07f, 0.07f, 0.0f, false, true, 0.08f, -0.01f)
                curveToRelative(3.93f, 1.79f, 8.18f, 1.79f, 12.06f, 0.0f)
                arcToRelative(0.07f, 0.07f, 0.0f, false, true, 0.08f, 0.01f)
                curveToRelative(0.12f, 0.10f, 0.25f, 0.20f, 0.37f, 0.29f)
                arcToRelative(0.08f, 0.08f, 0.0f, false, true, -0.01f, 0.13f)
                arcToRelative(12.30f, 12.30f, 0.0f, false, true, -1.87f, 0.89f)
                arcToRelative(0.08f, 0.08f, 0.0f, false, false, -0.04f, 0.11f)
                curveToRelative(0.36f, 0.70f, 0.77f, 1.36f, 1.23f, 1.99f)
                arcToRelative(0.08f, 0.08f, 0.0f, false, false, 0.08f, 0.03f)
                curveToRelative(1.96f, -0.61f, 3.95f, -1.52f, 6.00f, -3.03f)
                arcToRelative(0.08f, 0.08f, 0.0f, false, false, 0.03f, -0.06f)
                curveToRelative(0.5f, -5.18f, -0.84f, -9.67f, -3.55f, -13.66f)
                arcToRelative(0.06f, 0.06f, 0.0f, false, false, -0.03f, -0.03f)
                close()
                moveTo(8.02f, 15.33f)
                curveToRelative(-1.18f, 0.0f, -2.16f, -1.09f, -2.16f, -2.42f)
                curveToRelative(0.0f, -1.33f, 0.96f, -2.42f, 2.16f, -2.42f)
                curveToRelative(1.21f, 0.0f, 2.18f, 1.10f, 2.16f, 2.42f)
                curveToRelative(0.0f, 1.33f, -0.96f, 2.42f, -2.16f, 2.42f)
                close()
                moveTo(16.00f, 15.33f)
                curveToRelative(-1.18f, 0.0f, -2.16f, -1.09f, -2.16f, -2.42f)
                curveToRelative(0.0f, -1.33f, 0.96f, -2.42f, 2.16f, -2.42f)
                curveToRelative(1.21f, 0.0f, 2.18f, 1.10f, 2.16f, 2.42f)
                curveToRelative(0.0f, 1.33f, -0.95f, 2.42f, -2.16f, 2.42f)
                close()
            }
        }
        .build()
        return _discordSimpleIcons!!
    }

private var _discordSimpleIcons: ImageVector? = null
